import { tv } from 'tailwind-variants'

export const menuItemStyles = tv({
  slots: {
    container: 'flex w-full items-center gap-2 text-neutral-primary',
    icon: 'size-4 flex items-center justify-center shrink-0',
    text: 'body-small-basic',
    tooltipIcon: 'ml-auto text-neutral-primary',
  },
  variants: {
    variant: {
      critical: {
        container: 'text-status-critical-00',
      },
      disabled: {
        container: 'text-neutral-disabled',
      },
    },
  },
})
